module.exports = __webpack_public_path__ + "1aaa4dd420a279c2e0347c1886c8d4ee.svg";